<table>
  <tbody>
    <tr>
      <th>Qty</th>
      <th>Each</th>
      <th>Total</th>
    </tr>
    <tr>
      <td>
        @if (product.qtyBoxStyle == 'input') {
          <input class="rounded" type="number" mbnmQty min="1" [(ngModel)]="product.project.qty" />
        }
        @if (product.qtyBoxStyle == 'select') {
          <select class="rounded" [(ngModel)]="product.project.qty">
            @for (qty of product.qtyBoxValues; track qty) {
              <option>{{ qty }}</option>
            }
          </select>
        }
      </td>
      <td class="unit-price-container">
        @if (!product.project.qty) {
          <div class="unit-price">
            <span class="currency">?</span>
          </div>
        }
        @if (product.project.qty > 0) {
          <div class="unit-price">
            <span class="currency" [innerHtml]="product.project.price | currency2"></span>
          </div>
        }
      </td>
      <td class="unit-price-container">
        @if (product.project.qty > 0) {
          <div class="unit-price">
            @if (product.project.price != product.project.maxPrice) {
              <s [innerHtml]="product.project.maxPrice * product.project.qty | currency2"></s>
            }
            <span class="currency" [ngClass]="{cents: product.project.qty * product.project.price < 1}" [innerHtml]="product.project.qty * product.project.price | currency2"></span>
            @if (product.project.price != product.project.maxPrice) {
              <span class="savings">
                Save {{(1 - product.project.price / product.project.maxPrice) | percent:'1.0-0'}}
              </span>
            }
          </div>
        }
        @if (!product.project.qty) {
          <div class="unit-price">
            <span class="currency">?</span>
          </div>
        }
      </td>
    </tr>
  </tbody>
</table>
